import { Box, Typography } from "@mui/material";
import { Tile } from "@volt_developers/components";

interface BankTileProps {
  bankName: string;
  currency: string;
  additionalInfo?: string | (string | undefined)[];
}

export default function BankTile({
  bankName,
  currency,
  additionalInfo,
}: BankTileProps) {
  return (
    <Tile
      data-testid={
        typeof additionalInfo === "string"
          ? additionalInfo
          : additionalInfo?.join(" ")
      }
      sx={{ flexGrow: 1, mb: 2, maxWidth: 382 }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", m: "7px 16px" }}>
        <Typography
          color="text.high"
          variant="tinyBold"
          sx={{ textAlign: "left", minHeight: 16 }}
        >
          {bankName}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", height: 20 }}>
          <Typography color="text.low" sx={{ mr: 1 }} variant="tiny">
            {currency}
          </Typography>
          {typeof additionalInfo === "string" ? (
            <Typography color="text.low" variant="tiny">
              {additionalInfo}
            </Typography>
          ) : (
            additionalInfo?.map((info) => (
              <Typography
                key={info}
                color="text.low"
                variant="tiny"
                sx={{ mr: 1 }}
              >
                {info}
              </Typography>
            ))
          )}
        </Box>
      </Box>
    </Tile>
  );
}
